import {
    ChangeDetectionStrategy,
    Component,
    Injector,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FiChipsSelectSearchComponent } from '../fi-chips-select-search.component';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TItemWithChildren } from '@fi-shared/fi-select-search/select-search-base';
import { FiConnectedDropdownItemsComponent } from '@fi-shared/fi-connected-dropdown-items/fi-connected-dropdown-items.component';

@Component({
    selector: 'fi-chips-checkbox-select-search',
    templateUrl: './fi-chips-checkbox-select-search.component.html',
    styleUrls: ['../fi-chips-select-search.component.scss', './fi-chips-checkbox-select-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chips-checkbox-select-search' },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiChipsCheckboxSelectSearchComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiChipsCheckboxSelectSearchComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiChipsCheckboxSelectSearchComponent<T, TRes>
    extends FiChipsSelectSearchComponent<T, TRes>
    implements OnInit
{
    protected listItemPaddingPerLevel: number = 16;
    constructor(injector: Injector) {
        super(injector);
    }

    @Input() parentIdPropName: string = 'ParentId';
    @Input() valuePropName: string = 'Id';
    @Input() collapsedMode = false;

    @ViewChild(FiConnectedDropdownItemsComponent) connectedDropdownItemsComponent: FiConnectedDropdownItemsComponent<T>;

    ngOnInit(): void {
        this.listItemBasePadding = 36;
        this.listItemPaddingPerLevel = 24;
        super.ngOnInit();
    }

    getItemDisplayValue(item: TItemWithChildren<T>) {
        return item[this.displayValue];
    }

    protected updateFilteredItems() {
        const filteredItems = this.getFilteredItems();
        if (this.searchText && this.connectedDropdownItemsComponent) {
            this.connectedDropdownItemsComponent.expandItems(filteredItems as TItemWithChildren<T>[], {
                collapsePreviouslyExpandedItems: true,
            });
        }
        this.filteredItems$.next(filteredItems);
    }

    getFilteredItems(): TItemWithChildren<T>[] {
        const filterFn = (item: TItemWithChildren<T>) =>
            this.isItemNameIncludesSearchText(item) &&
            (this.includeDisabledToSearchResult || !this.searchText || !this.isOptionDisabled(item));
        setTimeout(() => this.cdr.markForCheck());
        return this.deepChildrenSearch(this.itemGroups$.value, filterFn);
    }

    onAutocompleteOpened() {
        super.onAutocompleteOpened();
        if (!this.collapsedMode) {
            this.setExpandableItems();
        }
        this.expandSelectedItems();
    }
}
